import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import apiCall from '../../../apiCall';
import { baseUrl, customHeaders, uaeProjectsBaseURL } from './../../../../../Containers/Config/index';

import { UPDATE_PARTNER, UPDATE_PARTNER_SUCCESS, UPDATE_PARTNER_ERROR } from './../../../actionType';
import { Constant } from '../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* updatePartner({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/partners`,
      method: 'PUT',
      headers: { Authorization: Constant?.CLIENT_TOKEN, ...customHeaders },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({ type: UPDATE_PARTNER_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: UPDATE_PARTNER_ERROR, payload: response.error });
    }
  } catch (error) {
    yield put({ type: UPDATE_PARTNER_ERROR, payload: error });
  }
}

export function* watchUpdatePartner() {
  yield takeEvery(UPDATE_PARTNER, updatePartner);
}

function* updatePartnerSaga() {
  yield all([fork(watchUpdatePartner)]);
}

export default updatePartnerSaga;
